export default {"src":"/_next/static/media/multiply_filled.a59fe2a0.svg","height":24,"width":24};